<template>
  <div>
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card :title="authors" subTitle="Autores">
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-notes text-warning"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-refresh"></i> Actualizado al cargar la página
            </template>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card :title="books" subTitle="Líbros físicos">
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-paper-2 text-success"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-calendar-o"></i> Actualizado al cargar la página
            </template>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card :title="users" subTitle="Usuarios">
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-single-02 text-danger"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-clock-o"></i> Actualizado al cargar la página
            </template>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card :title="transactions" subTitle="Transacciones">
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-single-copy-04 text-primary"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-refresh"></i> Actualizado al cargar la página
            </template>
          </stats-card>
        </div>

      </div>
      
  </div>
</template>
<script>
  import {ChartCard, StatsCard, Card, Table as LTable, Checkbox} from 'src/components/index'

  export default {
    components: {
      StatsCard
    },
    data () {
      return {
        authors: 42,
        books: 55,
        users: 13,
        transactions: 38
      }
    },
    mounted () {
      this.$checkToken();
    }
  }
</script>
<style>

</style>
